import FieldType from "./field-type";

export const AllTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.image,
    FieldType.check,
    FieldType.url,
    FieldType.formula,
    FieldType.linked,
    FieldType.lookup,
    FieldType.number,
    FieldType.uid,
    FieldType.pointer,
    FieldType.rollup
];

export const EntityFilterTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.datetime,
    FieldType.check,
    FieldType.formula,
    FieldType.linked,
    FieldType.number
];

export const ValuableTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.url,
    FieldType.number
];

export const ExcelExportTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.check,
    FieldType.url,
    FieldType.formula,
    FieldType.number
];

export const DefaultRefTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.url,
    FieldType.number,
    FieldType.linked
];

export const PrimaryTypes: FieldType[] = [
    FieldType.text,
    FieldType.email,
    FieldType.phone,
    FieldType.url,
    FieldType.number,
    FieldType.datetime,
    FieldType.textarea
];

export const PublicTableTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.image,
    FieldType.check,
    FieldType.url,
    FieldType.formula,
    FieldType.linked,
    FieldType.lookup,
    FieldType.number
];

export const PublicFormTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.image,
    FieldType.check,
    FieldType.url,
    FieldType.linked,
    FieldType.number
];

export const DataExportTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.image,
    FieldType.check,
    FieldType.url,
    FieldType.linked,
    FieldType.number
];

export const ServerTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.image,
    FieldType.check,
    FieldType.url,
    FieldType.number,
    FieldType.uid,
    FieldType.pointer,
    FieldType.rollup
];

export const TextyTypes: FieldType[] = [
    FieldType.text,
    FieldType.textarea,
    FieldType.email,
    FieldType.phone,
    FieldType.datetime,
    FieldType.url,
    FieldType.formula,
    FieldType.linked,
    FieldType.lookup,
    FieldType.number,
    FieldType.rollup
];